import { Button, Icon } from "armstrong-react";
import React from "react";

import { IRowAction, IRowActionSet } from ".";
import "./rowActionList.scss";

/**
 * Render the row actions of a table def for a dropdown
 */
export class RowActionList<T> extends React.PureComponent<{ item: T, set: IRowActionSet<T> }> {
  private renderAction = (action: IRowAction<T>): JSX.Element => {
    const item = this.props.item;

    if (action.render) {
      return action.render(item, () => action.actionSingle(item));
    }
    else {
      const text = typeof action.label === "string" ? action.label : action.label(item);
      return (
        <Button leftIcon={action.icomoon} key={`row-drawer-action-${item}`} onClick={() => action.actionSingle(item)}>
          {text}
        </Button>
      );
    }
  }

  private renderActionSet = (set: IRowActionSet<T>): JSX.Element => {
    const actions = (set.actions || []).filter(a => a.visible ? a.visible(this.props.item) : true);

    let label = typeof set.label === "string" ? set.label : set.label(this.props.item);
    label = (label || "").trim();
    if (label === "") {
      label = null;
    }

    return (
      <div className="ra-group">
        {label && <h4>{set.icomoon && <Icon icon={set.icomoon} />} {label}</h4>}
        <ul>
          {actions.length < 1 && <li className="no-actions"><em>There's nothing to do here.</em></li>}
          {actions.length > 0 && actions.map((action, index) => (
            <li key={`row-action-${index}`}>
              {action.isGroup && this.renderActionSet(action)}
              {action.isGroup === false && this.renderAction(action)}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  public render() {
    return (
      <div className="row-action-list">
        {this.renderActionSet(this.props.set)}
      </div>
    );
  }
}
